module.exports = __webpack_public_path__ + "static/img/search_2.5179f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search_2.png
// module id = BkWO
// module chunks = 1